import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      width={48}
      height={48}
      className="svg__loading"
      viewBox="0 0 36 36"
      fill="none"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)" fill="#D2D0D0">
        <path d="M35.965 10.584c-.085-1.913-.394-3.228-.837-4.367a8.785 8.785 0 00-2.082-3.193A8.86 8.86 0 0029.86.949C28.714.506 27.406.197 25.493.113 23.566.02 22.954 0 18.067 0c-4.888 0-5.5.021-7.42.105C8.735.19 7.42.5 6.28.942a8.784 8.784 0 00-3.193 2.082A8.863 8.863 0 001.013 6.21C.57 7.356.26 8.664.176 10.577c-.092 1.927-.113 2.539-.113 7.426 0 4.888.021 5.5.106 7.42.084 1.913.394 3.228.837 4.367a8.877 8.877 0 002.081 3.193 8.86 8.86 0 003.186 2.075c1.146.443 2.454.752 4.367.836 1.92.085 2.532.106 7.42.106s5.5-.021 7.42-.106c1.912-.084 3.227-.393 4.366-.836a9.208 9.208 0 005.268-5.268c.443-1.146.752-2.454.837-4.367.084-1.92.105-2.532.105-7.42 0-4.887-.007-5.499-.091-7.419zm-3.242 14.698c-.078 1.758-.373 2.708-.619 3.34a5.972 5.972 0 01-3.418 3.419c-.633.246-1.59.541-3.34.618-1.9.085-2.469.106-7.272.106-4.804 0-5.38-.021-7.272-.106-1.758-.077-2.708-.372-3.34-.618a5.539 5.539 0 01-2.068-1.344 5.597 5.597 0 01-1.343-2.067c-.246-.633-.542-1.59-.619-3.34-.085-1.9-.105-2.47-.105-7.273 0-4.803.02-5.38.105-7.271.077-1.758.373-2.708.619-3.34.288-.781.745-1.491 1.35-2.068A5.588 5.588 0 017.47 3.995c.633-.247 1.59-.542 3.34-.62 1.899-.084 2.469-.105 7.272-.105 4.81 0 5.38.021 7.272.106 1.758.077 2.707.372 3.34.619.78.288 1.491.745 2.068 1.343a5.596 5.596 0 011.343 2.067c.246.633.541 1.59.619 3.34.084 1.9.105 2.47.105 7.272 0 4.804-.02 5.367-.105 7.265z" />
        <path d="M18.067 8.756c-5.106 0-9.248 4.142-9.248 9.247 0 5.106 4.142 9.248 9.248 9.248 5.106 0 9.248-4.142 9.248-9.248 0-5.105-4.142-9.247-9.248-9.247zm0 15.246a6 6 0 010-11.997 6 6 0 010 11.997zM29.84 8.39a2.16 2.16 0 11-4.319 0 2.16 2.16 0 014.319 0z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h36v36H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgComponent
